import { cn } from "../../utils/cn";

interface CloseButtonProps {
  onClick?: () => void;
  className?: string;
  "aria-label"?: string;
}

const buttonStyles =
  "inline-flex items-center justify-center p-1 rounded-full outline-none " +
  "text-loch " +
  "hover:bg-loch-50 " +
  "focus-visible:border focus-visible:border-loch " +
  "active:bg-loch-100";

export const CloseButton = ({ onClick, className, "aria-label": ariaLabel = "Close" }: CloseButtonProps) => {
  return (
    <button type="button" className={cn(buttonStyles, className)} onClick={onClick} aria-label={ariaLabel}>
      <i
        className="fa-sharp fa-regular fa-xmark text-[20px] size-5 flex items-center justify-center"
        aria-hidden="true"
      />
    </button>
  );
};
